import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as RB from "react-bootstrap";

function SecondBasicInstallation({
  trialReportData,
  setTrialReportData,
  isDisable,
}) {
  const handleInputChange = (field, value) => {
    setTrialReportData((prevState) => ({ ...prevState, [field]: value }));
  };

  return (
    <>
      <RB.Col md={6}>
        <div className="mb-3">
          <RB.FloatingLabel
            controlId="trialReport"
            label="Trial Report"
            className="floating-label-fancy"
          >
            <RB.Form.Control
              type="text"
              placeholder="Trial Report"
              disabled={isDisable}
              value={trialReportData.trialReport}
              onChange={(e) => handleInputChange("trialReport", e.target.value)}
            />
          </RB.FloatingLabel>
        </div>
      </RB.Col>
      <RB.Col md={6}>
        <div className="mt-3">
          <DatePicker
            selected={trialReportData.dateOfCompletionOfTrialRun}
            onChange={(date) =>
              handleInputChange("dateOfCompletionOfTrialRun", date)
            }
            className="form-control"
            dateFormat="dd-MM-yyyy"
            placeholderText="Select Date of Completion of Trial Run"
            disabled={isDisable}
          />
        </div>
      </RB.Col>

      <RB.Col md={6}>
        <div className="mb-3">
          <RB.FloatingLabel
            controlId="assetsTagNo"
            label="Assets Tag No."
            className="floating-label-fancy"
          >
            <RB.Form.Control
              type="text"
              placeholder="Assets Tag No."
              disabled={isDisable}
              value={trialReportData.assetsTagNo}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  handleInputChange("assetsTagNo", value);
                }
              }}
            />
          </RB.FloatingLabel>
        </div>
      </RB.Col>

      <RB.Col md={6}>
        <div className="mt-3">
          <DatePicker
            disabled={isDisable}
            selected={trialReportData.dateOfCommencementOfProduction}
            onChange={(date) =>
              handleInputChange("dateOfCommencementOfProduction", date)
            }
            className="form-control"
            dateFormat="dd-MM-yyyy"
            placeholderText="Select Commencement of Commercial Production / Capitalisation Date"
          />
        </div>
      </RB.Col>

      <RB.Col md={6}>
        <div className="mb-3">
          <RB.FloatingLabel
            controlId="specialBenefits"
            label="Special Benefits / Classification"
            className="floating-label-fancy"
          >
            <RB.Form.Control
              disabled={isDisable}
              type="text"
              value={trialReportData.specialBenefits}
              onChange={(e) =>
                handleInputChange("specialBenefits", e.target.value)
              }
              placeholder="Special Benefits / Classification / Category, if any"
            />
          </RB.FloatingLabel>
        </div>
      </RB.Col>

      {/* <RB.Col md={6}>
        <div className="mb-3">
          <RB.FloatingLabel
            controlId="poNo"
            label="P.O. No."
            className="floating-label-fancy"
          >
            <RB.Form.Control
              placeholder="P.O. No."
              type="text"
              value={trialReportData.poNo}
              onChange={(e) => handleInputChange("poNo", e.target.value)}
            />
          </RB.FloatingLabel>
        </div>
      </RB.Col>

      <RB.Col md={6}>
        <div className="mt-3">
          <DatePicker
            selected={trialReportData.poDate}
            onChange={(date) => handleInputChange("poDate", date)}
            className="form-control"
            dateFormat="dd-MM-yyyy"
            placeholderText="Select P.O. Date"
          />
        </div>
      </RB.Col> */}
    </>
  );
}

export default SecondBasicInstallation;
